import { atom } from 'jotai';

export type ModalType =
  | undefined
  | 'resumeLearning'
  | 'apiError'
  | 'deleteStoreProduct'
  | 'reportMain'
  | 'reportConfirm'
  | 'nextLesson'
  | 'timelineContent'
  | 'lessonQuiz'
  | 'lessonQuizForm'
  | 'questionAnswer'
  | 'enrollConfirmation'
  | 'duplicateEnroll'
  | 'enrollInformation'
  | 'sequentialLearning'
  | 'alert'
  | 'confirm'
  | 'deleteAnswer'
  | 'blockUser'
  | 'waitingExam'
  | 'waitingSurvey'
  | 'waitingLesson'
  | 'confirmTakeExam'
  | 'confirmTakeSurvey'
  | 'askForDelete'
  | 'termsPrivacy'
  | 'missionConfirmDeleteFeedback'
  | 'missionConfirmCancel'
  | 'rewardCertificateDetail'
  | 'joinPolicy'
  | 'examFeedbackIssue'
  | 'lessonList'
  | 'popup'
  | 'lessonResource'
  | 'moveToNextLesson'
  | 'examQna'
  | 'imagePreview'
  | 'lessonRegularEvaluationUnderProgression'
  | 'productConfirmCancelWrite'
  | 'productConfirmDeleteSelectedItems'
  | 'mobileModifyCommentInput'
  | 'myClassTerminatedClass'
  | 'myClassNotInLearningPeriod'
  | 'degreeNotice'
  | 'processStock';

export type ModalStateProps = {
  open: boolean;
  type: ModalType;
  onClose: VoidFunction;
  data: any;
};

export const modalState = atom<ModalStateProps>({
  open: false,
  type: undefined,
  onClose: () => {},
  data: undefined,
});
